import React from 'react';
import CardList from '../components/card/CardList';
import Layout from '../components/Layout/Layout';

function Home() {
  return (
    <Layout>
     <CardList />
    </Layout>
  );
}

export default Home;
